<nav class="navbar fixed-top">
  <div class="d-flex align-items-center navbar-left">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
      href="javascript:;" class="menu-button d-none d-md-block">
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1"/>
        <rect x="0.48" y="7.5" width="7" height="1"/>
        <rect x="0.48" y="15.5" width="7" height="1"/>
      </svg>
      {{" "}}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1"/>
        <rect x="1.56" y="7.5" width="16" height="1"/>
        <rect x="1.56" y="15.5" width="16" height="1"/>
      </svg>
    </a>

    <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1"/>
        <rect x="0.5" y="7.5" width="25" height="1"/>
        <rect x="0.5" y="15.5" width="25" height="1"/>
      </svg>
    </a>

    <div class="btn-group ml-2" dropdown *ngIf="!isSingleLang">
      <button dropdownToggle type="button" class="language-button dropdown-toggle btn btn-light btn-sm">
        {{currentLanguage | uppercase}} <span class="caret"></span>
      </button>
      <ul *dropdownMenu class="dropdown-menu" role="menu">
        <li role="menuitem" *ngFor="let item of languages" (click)="onLanguageChange(item)"><a class="dropdown-item"
          href="javascript:;">{{item.label}}</a></li>
      </ul>
    </div>
  </div>

  <a class="navbar-logo" [routerLink]="appRoot">
    <span class="logo d-none d-xs-block"></span>
    <span class="logo-mobile d-block d-xs-none"></span>
  </a>

  <div class="navbar-right">
    <div class="header-icons d-inline-block align-middle">

      <div class="d-inline-block align-text-bottom mr-2" *ngIf="contracts.length > 1">
        <div class="btn-group" dropdown>
          <button id="btn-active-contract" dropdownToggle type="button"
            class="btn btn-outline-primary btn-xs dropdown-toggle text-extra-small"
            aria-controls="dropdown-active-contract">
            <i class="far fa-file-alt pr-1"></i>
            <span class="d-none d-xl-inline-block">{{activeContract.friendly_reference}}</span>
            <span class="caret"></span>
          </button>
          <ul id="dropdown-active-contract" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
            aria-labelledby="btn-active-contract">
            <li role="menuitem" *ngFor="let contract of contracts">
              <a class="dropdown-item text-extra-small text-muted py-1 px-3" (click)="onActiveContractChange(contract)">
                <i class="fas fa-check pr-1 text-primary" *ngIf="contract.id === activeContract.id"></i>
                {{contract.friendly_reference}}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="d-none d-md-inline-block align-text-bottom mr-1">
        <i class="text-muted text-one fas px-1"
          [class.fa-moon]="isDarkModeActive"
          [class.fa-sun]="!isDarkModeActive"
          [tooltip]="isDarkModeActive ? 'Dark Mode' : 'Light Mode'"
          placement="left">
        </i>
      </div>

      <div class="d-none d-md-inline-block align-text-bottom mr-1">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="darkModeSwitch" [checked]="isDarkModeActive"
            (change)="onDarkModeChange()">
          <label class="custom-control-label" for="darkModeSwitch"></label>
        </div>
      </div>

      <div *ngIf="iconMenus.length > 0" class="position-relative d-none d-sm-inline-block">
        <div dropdown>
          <button dropdownToggle type="button" class="header-icon btn btn-empty">
            <i class="simple-icon-grid"></i>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-right mt-3" role="menu" aria-labelledby="button-basic"
            id="iconMenuDropdown">
            <a *ngFor="let iconMenu of iconMenus;"
              role="menuitem" (click)="iconMenu.click();" class="icon-menu-item dropdown-item c-pointer col p-3">
              <i [class]="iconMenu.icon + ' d-block'"></i>
              <span>{{iconMenu.title}}</span>
            </a>
          </div>
        </div>
      </div>

      <button class="header-icon btn btn-empty d-none d-sm-inline-block" type="button" id="fullScreenButton"
        (click)="fullScreenClick()">
        <i *ngIf="!isFullScreen" class="simple-icon-size-fullscreen"></i>
        <i *ngIf="isFullScreen" class="simple-icon-size-actual"></i>
      </button>

    </div>

    <div class="user d-inline-block" dropdown>
      <button class="btn btn-empty p-0" type="button" dropdownToggle>
        <span class="name">{{displayName}}</span>
        <span>
          <img alt="Profile Picture" [src]="userAvatar"/>
        </span>
      </button>

      <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
        <a class="dropdown-item c-pointer" (click)="onMyContractDetails()">My Contract Details</a>
        <div class="divider dropdown-divider"></div>
        <a class="dropdown-item c-pointer" (click)="onMyDetails()">My Details</a>
        <div class="divider dropdown-divider"></div>
        <a class="dropdown-item c-pointer" (click)="onChangePassword()">Change Password</a>
        <div class="divider dropdown-divider"></div>
        <a class="dropdown-item c-pointer" (click)="onSignOut()">Sign out</a>
      </div>
    </div>

  </div>
</nav>
